import { useTranslation } from 'react-i18next'
import { CircularProgress, Switch } from '@mui/material'
import { AuroraCirculationPumpStatus } from '../enums'
import AuroraControl from './AuroraControl'

export interface AuroraCirculationPumpStatusControlProps {
  value: AuroraCirculationPumpStatus
  loading?: boolean
  disabled?: boolean
  onSubmit: (value: AuroraCirculationPumpStatus) => Promise<void>
}

export default function AuroraCirculationPumpStatusControl({
  value,
  loading = false,
  disabled = false,
  onSubmit
}: AuroraCirculationPumpStatusControlProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('aurora')

  /**
   * Indicates if the control is checked.
   */
  const isChecked = value === AuroraCirculationPumpStatus.ON

  /**
   * Handle the change event.
   */
  async function handleChange(_: React.ChangeEvent<HTMLInputElement>, checked: boolean) {
    try {
      await onSubmit(checked ? AuroraCirculationPumpStatus.ON : AuroraCirculationPumpStatus.OFF)
    } catch {
      // Ignore the error.
    }
  }

  return (
    <AuroraControl
      label={t('circulationPump')}
      value={isChecked ? t('on') : t('off')}
      loading={loading}
      disabled={disabled}
      control={
        loading ? (
          <CircularProgress size={24} sx={{ mr: 4 }} />
        ) : (
          <Switch color="success" checked={isChecked} onChange={handleChange} disabled={disabled} />
        )
      }
    />
  )
}
